// extracted by mini-css-extract-plugin
module.exports = {"select":"Select_select__347yi","spinAround":"Select_spinAround__2uxvd"};